import constants from "../../../utils/constants";
const processTypes = {
  heating: 1,
  cooling: 2,
  mix: 3,
  adiabatic: 4,
  steam: 5,
  theory: 6,
};

const point = {
  temperatureDryBulb: 0,
  temperatureWetBulb: 0,
  temperatureDewPoint: 0,
  relativeHumidity: 0,
  absoluteHumidity: 0,
  enthalpy: 0,
  airFlowHours: 0,
  airFlowSeconds: 0,
  massFlow: 0,
  realFlow: 0,
  airDensity: 0,
  usedPower: 0,
  usedWater: 0,
  process: 0,
};

export const calculateAirPressure = (elevation) =>
  Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * elevation * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );

export const calculatePD = (temperature) => {
  console.log("KOJU TEMP SALJEM" + temperature);
  let pd;
  if (temperature < -50) return undefined;
  else if (temperature >= -50 && temperature < 0)
    return Math.exp((1738.4 + 28.74 * temperature) / (271 + temperature));
  else if (temperature >= 0 && temperature <= 100)
    return Math.exp((1500.3 + 23.5 * temperature) / (234 + temperature));
  else return undefined;
};

export const calculateMassFlow = (Vh, Vs) => {
  if (Vh !== null) return (Vh / 3600) * 1.2;
  else if (Vs !== null) return Vs * 1.2;
  else return 0;
};

export const calculateCoolerPD = (coolerTemperature) => {
  // return calculatePD(coolerTemperature) * 1000;
  return calculatePD(coolerTemperature);
};
export const calculateCoolerAbsHumidity = (coolerTemperature, elevation) => {
  //console.log("airPressure" + calculateAirPressure(elevation));
  // console.log("cooler pd" + calculateCoolerPD(coolerTemperature));

  return (
    (0.6222 * calculateCoolerPD(coolerTemperature)) /
    (calculateAirPressure(elevation) / 1000 -
      calculateCoolerPD(coolerTemperature) / 1000)
  );
};

export const calculateCoolerEnthalpy = (coolerTemperature, elevation) => {
  console.log(coolerTemperature);
  return (
    1.01 * coolerTemperature +
    ((2501 + 1.86 * coolerTemperature) *
      calculateCoolerAbsHumidity(coolerTemperature, elevation)) /
      1000
  );
};

export const heating = (startTemperature, startAbsHumidity, endTemperature) => {
  //Potrebno je ubaciti i kalkulaciju za sve ostale parametre
  return [
    { temperature: startTemperature, humidity: startAbsHumidity },
    { temperature: endTemperature, humidity: startAbsHumidity },
  ];
};

export const cooling = (
  startTemperature,
  startAbsHumidity,
  endTemperature,
  P,
  Vh,
  Vs,
  massFlowFromPrevious,
  coolerTemperature,
  elevation,
  maxHumidityInProcess,
  enthalpyFromPrevProcess,
  absHumidityFromPrevious
) => {
  let linePoints = [
    { temperature: startTemperature, humidity: startAbsHumidity },
  ];
  let absoluteHumidity;

  //Formule iz dela Znamo t,h

  let limitPDperT = calculatePD(endTemperature);
  //console.log("HLADJ staro limitPDperT" + limitPDperT);
  let limitXperT =
    (0.6222 * (maxHumidityInProcess / 100) * limitPDperT) /
    (calculateAirPressure(elevation) / 1000 -
      ((maxHumidityInProcess / 100) * limitPDperT) / 1000);
  //console.log("HLADJ staro limitXperT" + limitXperT);
  //Racunamo x na osnovu entalpije

  //Iz formula za hladjenje
  let lastH;
  //Slucaj da je uneta kolicina predate kolicine toplote (utrosena snaga) P u kW
  let massFlow;
  if (Vh !== null || Vs !== null) {
    massFlow = calculateMassFlow(Vh, Vs);
  } else {
    //if (processType !== processTypes.mix)
    massFlow = massFlowFromPrevious;
    //else if (processType === processTypes.mix)
    //massFlow = massFlowFromPrevious + massFlowFromSecondPrevious
    //else
    //massFlow = undefined}
  }

  //let massFlowFromPrevious;

  if (Vh !== null || Vs !== null) {
    if (Vh !== null) massFlowFromPrevious = (Vh / 3600) * 1.2;
    else if (Vs !== null) massFlowFromPrevious = Vs * 1.2;
    else massFlowFromPrevious = 0;
  }
  console.log("HLADJ massFlow staro" + massFlow);

  if (P !== null) lastH = enthalpyFromPrevProcess - Math.abs(P / massFlow);
  else {
    if (
      calculateCoolerAbsHumidity(coolerTemperature, elevation) <
      absHumidityFromPrevious
    )
      lastH =
        enthalpyFromPrevProcess -
        ((enthalpyFromPrevProcess -
          calculateCoolerEnthalpy(coolerTemperature, elevation)) *
          (endTemperature - startTemperature)) /
          (coolerTemperature - startTemperature);
    else lastH = "1";
  }
  console.log("HLADJ staro lastH" + lastH);
  let xPerH =
    ((lastH - 1.01 * endTemperature) / (2501 + 1.86 * endTemperature)) * 1000;
  console.log("HLADJ staro xPerH" + xPerH);
  if (xPerH < limitXperT) absoluteHumidity = xPerH;
  else absoluteHumidity = limitXperT;
  linePoints.push({ temperature: endTemperature, humidity: absoluteHumidity });
  console.log("HLADJ staro absHum" + absoluteHumidity);
  return linePoints;
};
